
export default function initResetPassword() {

    //TODO: replace this with reset password / initial password set form once initial dev / testing is complete
    if (!document.querySelector("#resetPassword")) return;

    bindPwdStrengthMeter();

    $('#Password').tooltip();
}

const props = {
    passwordId: '#Password',
    passwordStrengthMeter: '.password-strength-meter',
    passwordStrengthText: '.password-strength-text',
};

var strength = {
    0: "Poor",
    1: "Weak",
    2: "Medium",
    3: "Good",
    4: "Strong"
}

function bindPwdStrengthMeter() {

    var password = $(props.passwordId);

    password.off('keyup').on('keyup', function (e) {

        var meter = $(props.passwordStrengthMeter);
        var text = $(props.passwordStrengthText);

        var val = $(this).val();

        var complexityScoreValue = complexityScore();

        // Update the password strength meter
        meter.val(complexityScoreValue);

        // Update the text indicator
        if (val !== "") {

            if (e.keyCode !== undefined) {
                displayIndicator(true);
                text.html(strength[complexityScoreValue]);
            }

        } else {
            text.html("");
            displayIndicator(false);
        }

    });

    password.off('focus').on('focus', function (e) {

        e.stopImmediatePropagation();
        displayIndicator(true);
    });

    password.off('blur').on('blur', function () {

        displayIndicator(false); 
    });
}

function displayIndicator(boolValue) {

    var entity = $('#complexity-indicator-desktop');

    if (boolValue) {

        if ($(props.passwordId).val().length > 0) {

            entity.show(500);
        }

    } else {

        entity.hide(500);
    }

}

function complexityScore() {

    //password strength will measure on a score of 0 through 4
    //components:

    // - length
    // - numeric characters
    // - capital letters
    // - non-numeric

    //"Poor" - no numbers, capitals or non-alpha. less than 8 chars
    //"Weak" - above 8 chars. 1 of numbers, capitals or non-alpha
    //"Good" - above 8 chars. 2 of numbers, capitals or non-alpha
    //"Strong" - above 8 chars. 3 of numbers, capitals or non-alpha

    var val = $('#Password').val();

    if (val.length === 0) {

        return 0;
    }

    var meetsMinimumLength = $('#Password').val().length >= 8;
    var hasUpperCaseChar = hasUpperCase(val);
    var hasNumberChar = hasNumber(val);
    var hasNonAlphanumericChar = hasNonAlphanumeric(val);

    var score = 0;

    if (meetsMinimumLength) {
        score = score + 1;
    }

    if (meetsMinimumLength && hasUpperCaseChar) {
        score = score + 1;
    }

    if (meetsMinimumLength && hasNumberChar) {
        score = score + 1;
    }

    if (meetsMinimumLength && hasNonAlphanumericChar) {
        score = score + 1;
    }

    return score;
}

function hasUpperCase(str) {
    return str.toLowerCase() != str;
}

function hasNumber(str) {
    return /\d/.test(str);
}

function hasNonAlphanumeric(str) {
    //test for presence of ONLY alpha numeric characters
    var result = /^([0-9]|[a-z])+([0-9a-z]+)$/i.test(str);

    //return the opposite of the regex to detect presence of non-alphanumeric chars.
    return !result;
}